<template>
  <div class="registration-success">
    <div class="content">
      <div class="success-icon">
        <i class="el-icon-success"></i>
      </div>
      <h1>Registration Successful!</h1>
      <p>Thank you for registering. </p>
      <!-- <p>You will receive a confirmation email shortly. Please check your email to activate your account.</p> -->
      
      <div class="actions">
        <el-button type="primary" @click="$router.push('/login')">
          Go to Login
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegistrationSuccess'
}
</script>

<style lang="scss" scoped>
.registration-success {
  min-height: 100vh;
  background-color: #fa6a51;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  .content {
    max-width: 600px;
    margin: 0 auto;
    background: white;
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    text-align: center;

    .success-icon {
      font-size: 80px;
      color: #67c23a;
      margin-bottom: 24px;
    }

    h1 {
      color: #303133;
      margin-bottom: 16px;
    }

    p {
      color: #606266;
      margin-bottom: 8px;
    }

    .actions {
      margin-top: 32px;

      .el-button {
        width: 200px;
        height: 45px;
        border-radius: 22px;
      }
    }
  }
}

::v-deep {
  .el-button--primary {
    background-color: #fa6a51;
    border-color: #fa6a51;
  }
}
</style> 